export const MAX_DAYS_WITHOUT_CHECKING = 30
const MILISECONDS_IN_A_DAY = 24 * 60 * 60 * 1000

const MAX_TIME_WITHOUT_CHECKING_MILISECONDS_IN_PRODUCTION =
  MAX_DAYS_WITHOUT_CHECKING * MILISECONDS_IN_A_DAY
const ONE_MINUTE = 1 * 60 * 1000
const MAX_TIME_WITHOUT_CHECKING_MILISECONDS_IN_PRE_PRODUCTION = ONE_MINUTE

/**
 * @param {String} inDateChecked
 * @param {Date} dateNow
 * @param {boolean} isProduction
 * @return {boolean}
 */
export const dateCheckedExistsAndIsWithinLimit = (inDateChecked, dateNow, isProduction) => {
  if (inDateChecked && typeof inDateChecked === 'string') {
    const dateChecked = new Date(inDateChecked)
    // @ts-ignore
    if (isNaN(dateChecked)) {
      return false
    } else {
      const gracePeriodBetweenChecks = isProduction
        ? MAX_TIME_WITHOUT_CHECKING_MILISECONDS_IN_PRODUCTION
        : MAX_TIME_WITHOUT_CHECKING_MILISECONDS_IN_PRE_PRODUCTION
      const expiryDate = new Date(dateChecked.getTime() + gracePeriodBetweenChecks)
      return dateNow < expiryDate
    }
  } else {
    return false
  }
}

/**
 * @param {String} dateChecked
 * @param {String | Null} expiresAt
 * @param {Date} today
 * @param {boolean} isProduction
 * @return {boolean}
 */
export const proLicenseIsActive = (dateChecked, expiresAt, today, isProduction) => {
  if (dateCheckedExistsAndIsWithinLimit(dateChecked, today, isProduction)) {
    if (expiresAt && typeof expiresAt === 'string') {
      const dateExpiresAt = new Date(expiresAt)
      // @ts-ignore
      if (isNaN(dateExpiresAt)) {
        return false
      } else {
        const dateToday = new Date()
        return dateToday < dateExpiresAt
      }
    } else {
      return expiresAt === null
    }
  } else {
    return false
  }
}

/**
 * @param {String} dateCheckedAsString
 * @param {Date} today
 * @param {boolean} isProduction
 * @return {boolean}
 */
export const dateCheckedExistsAndIsOutsideLimit = (dateCheckedAsString, today, isProduction) => {
  const dateChecked = new Date(dateCheckedAsString)
  // @ts-ignore
  if (isNaN(dateChecked)) {
    return false
  } else {
    const gracePeriodBetweenChecks = isProduction
      ? MAX_TIME_WITHOUT_CHECKING_MILISECONDS_IN_PRODUCTION
      : MAX_TIME_WITHOUT_CHECKING_MILISECONDS_IN_PRE_PRODUCTION
    const dateToday = today
    const expiryDate = new Date(dateChecked.getTime() + gracePeriodBetweenChecks)
    return dateToday >= expiryDate
  }
}

/**
 * @param {String} dateChecked
 * @param {String | Null} expiresAt
 * @param {Date} today
 * @param {boolean} isProduction
 * @return {boolean}
 */
export const needsToCheckLicense = (dateChecked, expiresAt, today, isProduction) => {
  return expiresAt !== null && dateCheckedExistsAndIsOutsideLimit(dateChecked, today, isProduction)
}

/**
 * @param {String} dateChecked
 * @param {String | Null} expiresAt
 * @param {Date} today
 * @param {boolean} isProduction
 * @return {boolean}
 */
export const plottrLicenseIsActive = (dateChecked, expiresAt, today, isProduction) => {
  if (expiresAt === null) {
    return true
  } else if (dateCheckedExistsAndIsWithinLimit(dateChecked, today, isProduction)) {
    if (expiresAt && typeof expiresAt === 'string') {
      const dateExpiresAt = new Date(expiresAt)
      // @ts-ignore
      if (isNaN(dateExpiresAt)) {
        // Don't allow folks in if the data is invalid.
        return false
      } else {
        // But let anyone who once had a Plottr subscription in but
        // without updates.  See: hasNonExpiredPlottrLicenseSelector
        return true
      }
    } else {
      return expiresAt === null
    }
  } else {
    return false
  }
}

/**
 * @param {number} startsAt
 * @param {number} endsAt
 * @param {Date} today
 * @return {boolean}
 */
export const trialIsActive = (startsAt, endsAt, today) => {
  const todayInMS = today.getTime()
  return todayInMS >= startsAt && todayInMS <= endsAt
}
